import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";

var HighchartsReact = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(HighchartsReact, _React$PureComponent);

  var _super = _createSuper(HighchartsReact);

  function HighchartsReact(props) {
    var _this;

    _classCallCheck(this, HighchartsReact);

    _this = _super.call(this, props);
    _this.container = React.createRef();
    return _this;
  }

  _createClass(HighchartsReact, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var props = this.props;
      var highcharts = props.highcharts || window.Highcharts; // Create chart

      this.chart = highcharts[props.constructorType || "chart"](this.container.current, props.options, props.callback ? props.callback : undefined);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.allowChartUpdate !== false) {
        var _this$chart;

        (_this$chart = this.chart).update.apply(_this$chart, [this.props.options].concat(_toConsumableArray(this.props.updateArgs || [true, true])));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Destroy chart
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      // Create container for the chart
      return React.createElement("div", {
        ref: this.container
      });
    }
  }]);

  return HighchartsReact;
}(React.PureComponent);

export { HighchartsReact as default };